@use '@/scss/underscore' as _;

.actionButton {
  border-radius: 6px;
}
